<template>
    <v-row>
        <v-col>
            <v-checkbox v-model="isTextArea" label="Text Area" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, uses a bigger text area input instead of a normal single-line input.</span>
        </v-col>
        <v-col>
            <v-checkbox v-model="isReadOnly" label="Read Only" @change="emit"/>
            <span class="body-2 text--secondary">If enabled the field will be read only, so not editable.</span>
        </v-col>
        <v-col v-if="!isTextArea">
            <v-select :items="['text', 'number']" v-model="subType" label="Text Sub-Type" @change="emit"/>
            <span class="body-2 text--secondary">The input sub-type - <a href="https://www.w3schools.com/html/html_form_input_types.asp" target="_blank">the HTML input type</a>.</span>
        </v-col>
        <v-col v-if="!isTextArea && subType == 'number'">
            <v-text-field v-model="minValue" type="number" label="Minimum Value" @input="emit" @change="emit"/>
            <span class="body-2 text--secondary">The minimum value that can be entered.</span>
        </v-col>
        <v-col v-if="!isTextArea && subType == 'number'">
            <v-text-field v-model="maxValue" type="number" label="Maximum Value" @input="emit" @change="emit"/>
            <span class="body-2 text--secondary">The maximum value that can be entered.</span>
        </v-col>
        <v-col>
            <v-text-field v-model="textboxHeight" type="number" label="Textbox Height" @input="emit" @change="emit"/>
            <span class="body-2 text--secondary">The height of the text box in pixels.</span>
        </v-col>
        <v-col v-if="isTextArea">
            <v-text-field v-model="numberCachedValues" type="number" label="Number Cached Values" @input="emit" @change="emit"/>
            <span class="body-2 text--secondary">The number of cached values to store.</span>
        </v-col>
        <v-col v-if="isTextArea">
            <v-checkbox v-model="allowCacheDuplicates" label="Allow Cache Duplicates" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, duplicate texts will be stored as seaprate values in the cache.</span>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'TextComp',
        data: () => ({
            isTextArea: false,
            isReadOnly: false,
            subType: null,
            minValue: null,
            maxValue: null,
            textboxHeight: null,
            numberCachedValues: null,
            allowCacheDuplicates: false
        }),
        methods: {
            emit() {
                let opts = {};
                if(this.textboxHeight) {
                    opts.textboxHeight = parseInt(this.textboxHeight);
                }

                if (this.isReadOnly) {
                    opts.isReadOnly = this.isReadOnly;
                }

                if(this.isTextArea) {
                    opts.type = 'textarea';
                    if (this.numberCachedValues){
                        // Got cached values so add the 2 caching options
                        opts.numberCached = parseInt(this.numberCachedValues);
                        opts.allowCacheDuplicates = this.allowCacheDuplicates;
                    }
                } else {
                    opts.type = 'text';
                    if(this.subType) {
                        opts.subType = this.subType;
                        if(this.subType === 'number' && this.minValue) {
                            opts.minValue = parseInt(this.minValue);
                        }
                        if(this.subType === 'number' && this.maxValue) {
                            opts.maxValue = parseInt(this.maxValue);
                        }
                    }
                }

                this.$emit('change', opts);
            }
        },
        created() {
            this.emit();
        }
    }
</script>
